import { useApiClient, useAuth } from '@msdk/common'
import { useEffect, useState } from 'react'

export function useAuthFlow() {
  const api = useApiClient()
  const auth = useAuth()
  const [ping, setPing] = useState(0)

  useEffect(() => {
    const renew = async () => {
      await api.updateAuth(auth)
      setPing(Date.now())
    }
    renew()
  }, [])

  return ping
}
